import { collection, getDocs } from 'firebase/firestore';
import { dbFirestore } from '../appFirebase';

export const getCategories = async () => {
	const querySnapshot = await getDocs(collection(dbFirestore, 'categories'));
	const categories = [];
	querySnapshot.forEach(cat => {
		categories.push({ id: cat.id, ...cat.data() });
	});
	return categories;
};
